// LINFA — Living Herbarium PDP motion
// Ambient breathing, layered parallax, botanical particles, staggered blooms.
(function () {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const body = document.body;
  if (!reduce) body.classList.add("motion-on");

  let scrollY = window.scrollY;
  let ticking = false;
  const vh = () => window.innerHeight;

  const heroImg = document.querySelector(".pdp-hero-img");
  const heroInner = document.querySelector(".pdp-hero-inner");
  const heroSection = document.querySelector(".pdp-hero");

  if (heroSection && heroImg && !reduce) {
    const wrap = document.createElement("div");
    wrap.className = "pdp-hero-motion";
    heroImg.parentNode.insertBefore(wrap, heroImg);
    wrap.appendChild(heroImg);
    const overlay = document.createElement("div");
    overlay.className = "pdp-hero-overlay";
    heroSection.appendChild(overlay);
  }

  // Read tint from the hero
  let tint = "#5b7a3a";
  if (heroSection) {
    const inline = heroSection.getAttribute("style") || "";
    const m = inline.match(/--card-tint:\s*([^;]+)/);
    if (m) tint = m[1].trim();
  }

  function seedParticles(section, count) {
    if (reduce || !section) return;
    const layer = document.createElement("div");
    layer.className = "pdp-particles";
    layer.setAttribute("aria-hidden", "true");
    for (let i = 0; i < count; i++) {
      const p = document.createElement("span");
      p.className = "pdp-particle";
      const size = 8 + Math.random() * 22;
      p.style.setProperty("--sz", size + "px");
      p.style.setProperty("--x", Math.random() * 100 + "%");
      p.style.setProperty("--d", (12 + Math.random() * 18).toFixed(1) + "s");
      p.style.setProperty("--dl", (-Math.random() * 20).toFixed(1) + "s");
      p.style.setProperty("--r", Math.floor(Math.random() * 360) + "deg");
      p.style.setProperty("--o", (0.10 + Math.random() * 0.18).toFixed(2));
      p.style.setProperty("--tint", tint);
      layer.appendChild(p);
    }
    section.appendChild(layer);
  }

  seedParticles(document.querySelector(".pdp-intro"), 10);
  seedParticles(document.querySelector(".pdp-atlas"), 14);
  seedParticles(document.querySelector(".pdp-origin"), 8);

  // Reveals
  const revealables = document.querySelectorAll(
    ".pdp-intro-grid, .pdp-notes, .pdp-brewbox, .pdp-origin-grid, .pdp-steps, .pdp-prov-inner, .pdp-next, .pdp-atlas h2, .pdp-origin h2, .pdp-ritual h2"
  );
  if (revealables.length && "IntersectionObserver" in window) {
    revealables.forEach((el) => el.classList.add("pdp-reveal"));
    document
      .querySelectorAll(".pdp-notes, .pdp-steps, .pdp-prov-inner, .pdp-origin-grid")
      .forEach((grid) => {
        Array.from(grid.children).forEach((child, i) => {
          child.classList.add("pdp-reveal-child");
          child.style.setProperty("--i", i);
        });
      });
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -80px 0px" }
    );
    revealables.forEach((el) => io.observe(el));
  }

  // Living plants — each botanical illustration gets its own sway rhythm
  // so the plates on a page look like real specimens, not synchronised loops.
  if (!reduce) {
    const plants = document.querySelectorAll(
      ".pdp-intro-image img, .pdp-origin-image img"
    );
    plants.forEach((img, i) => {
      img.classList.add("plant-alive");
      // Sway between 9s and 14s; breathe between 6s and 9s. Negative delays
      // start each plant mid-cycle so nothing pops in.
      const swayDur = (1.2 + Math.random() * 1.0).toFixed(2) + "s";
      const swayDelay = (-Math.random() * 1.5).toFixed(2) + "s";
      const breatheDur = (4.5 + Math.random() * 2).toFixed(2) + "s";
      const breatheDelay = (-Math.random() * 3).toFixed(2) + "s";
      img.style.setProperty("--sway-dur", swayDur);
      img.style.setProperty("--sway-delay", swayDelay);
      img.style.setProperty("--breathe-dur", breatheDur);
      img.style.setProperty("--breathe-delay", breatheDelay);
    });
  }

  // Note tint drops
  document.querySelectorAll(".pdp-note").forEach((n) => {
    if (n.querySelector(".pdp-note-drop")) return;
    const drop = document.createElement("span");
    drop.className = "pdp-note-drop";
    drop.style.setProperty("--tint", tint);
    n.appendChild(drop);
  });

  function onScroll() {
    scrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }
  function update() {
    ticking = false;
    const y = scrollY;
    const heroWrap = document.querySelector(".pdp-hero-motion");
    if (heroWrap && y < vh() * 1.3) {
      const t = y * 0.42;
      const s = 1 + y * 0.00022;
      heroWrap.style.transform = `translate3d(0, ${t}px, 0) scale(${s})`;
    }
    if (heroInner && y < vh() * 1.1) {
      heroInner.style.transform = `translate3d(0, ${y * 0.18}px, 0)`;
      heroInner.style.opacity = Math.max(0, 1 - y / (vh() * 0.85)).toFixed(3);
    }
    const overlay = document.querySelector(".pdp-hero-overlay");
    if (overlay && y < vh()) {
      overlay.style.opacity = (0.15 + Math.min(0.30, (y / vh()) * 0.30)).toFixed(3);
    }
    const introImg = document.querySelector(".pdp-intro-image img");
    if (introImg) {
      const rect = introImg.getBoundingClientRect();
      const center = rect.top + rect.height / 2;
      const offset = (vh() / 2 - center) * 0.08;
      introImg.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0) scale(1.02)`;
    }
  }
  if (!reduce) {
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  // ---- Purchase strip wiring (variant chips + qty + add-to-cart) ----
  const form = document.querySelector('form[data-linfa-pdp-form]');
  if (form) {
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    const priceEl = document.querySelector('[data-pdp-price]');
    const submitBtn = form.querySelector('button[type="submit"]');
    const chips = form.querySelectorAll('.pdp-variants .chip');

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
        if (idInput) idInput.value = chip.dataset.variantId;
        if (priceEl && chip.dataset.variantPrice) priceEl.textContent = chip.dataset.variantPrice;
        const available = chip.dataset.variantAvailable === 'true';
        if (submitBtn) {
          submitBtn.disabled = !available;
          submitBtn.textContent = available ? (submitBtn.dataset.labelDefault || 'Add to pouch') : (submitBtn.dataset.labelSoldout || 'Sold out');
        }
      });
    });

    form.querySelectorAll('[data-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        let v = parseInt(qtyInput.value, 10) || 1;
        v += btn.dataset.qty === 'up' ? 1 : -1;
        qtyInput.value = Math.max(1, v);
      });
    });
  }
})();
